export const ROLE_TYPES = {
  ADMINISTRATOR: 'Administrator',
  MANAGER: 'Manager',
  STUDENT: 'Student',
  MENTOR: 'Mentor',
  Employee: 'Employee'
};